import * as React from "react"
import type { SVGProps } from "react"
const SvgThreePeopleFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M1 18a1 1 0 0 1-.71-.29A1 1 0 0 1 0 17v-.57q0-1.08 1.1-1.75A5.5 5.5 0 0 1 4 14l.63.01q.3.02.57.06a4 4 0 0 0-.7 2.3V18zm6 0a1 1 0 0 1-.71-.29A1 1 0 0 1 6 17v-.62q0-.81.44-1.47t1.23-1.16A6 6 0 0 1 9.6 13a11 11 0 0 1 2.41-.25q1.32 0 2.44.25t1.91.75 1.22 1.16.43 1.47V17q0 .42-.29.71-.29.3-.71.29zm12.5 0v-1.62q0-.66-.16-1.23t-.49-1.08q.27-.05.56-.06L20 14q1.8 0 2.9.66t1.1 1.77V17q0 .42-.29.71-.29.3-.71.29zM4 13q-.82 0-1.41-.59-.6-.59-.59-1.41 0-.85.59-1.43Q3.18 9 4 9q.85 0 1.42.57Q6 10.15 6 11q0 .83-.58 1.41-.57.6-1.42.59m16 0q-.83 0-1.41-.59-.6-.59-.59-1.41 0-.85.59-1.43Q19.18 9 20 9q.85 0 1.43.57.57.58.57 1.43 0 .83-.57 1.41-.58.6-1.43.59m-8-1a3 3 0 0 1-2.12-.87A3 3 0 0 1 9 9q0-1.27.88-2.14Q10.75 6 12 6q1.27 0 2.14.86Q15 7.73 15 9q0 1.25-.86 2.13-.87.87-2.14.87" />
  </svg>
)
export default SvgThreePeopleFilled
